export enum CreationType {
  BANNER = 'BANNER',
  HTML = 'HTML',
  NATIVE = 'NATIVE',
}

export enum Device {
  MOBILE = 'MOBILE',
  DESKTOP = 'DESKTOP',
}

export enum Capping {
  HOUR = 'HOUR',
  DAY = 'DAY',
}

export enum FieldType {
  EMAIL = 'EMAIL',
  ENUM = 'ENUM',
  NUMBER = 'NUMBER',
  STRING = 'STRING',
}

export enum CDPRecordMethod {
  INCLUDE = 'INCLUDE',
  EXCLUDE = 'EXCLUDE',
}

export const FLATFEE_SPECIFICATION_URL = 'https://reklama.wp.pl/strefa-klienta'
